import actions from '~/store/modules/shared/classifieds/actions/actions'
import mutations from '~/store/modules/shared/classifieds/actions/mutations'
import state from '~/store/modules/shared/classifieds/actions/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  mutations,
  state
})
